var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 112,
    viewBox: "0 0 104 112",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "password"
  }, /*#__PURE__*/React.createElement("g", {
    id: "password_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lock_ok"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8119 82.1835C54.8513 81.1529 56.25 79.0361 56.25 76.5921C56.25 73.1353 53.4518 70.333 50 70.333C46.5482 70.333 43.75 73.1353 43.75 76.5921C43.75 79.0361 45.1487 81.1529 47.1881 82.1835C46.9875 83.0078 46.875 83.9334 46.875 84.9116C46.875 88.3608 48.2741 91.1568 50 91.1568C51.7259 91.1568 53.125 88.3608 53.125 84.9116C53.125 83.9334 53.0125 83.0078 52.8119 82.1835Z",
    fill: "#3796F6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 9.08337,
    y: 50.25,
    width: 81.8333,
    height: 61,
    rx: 2.25,
    stroke: "#3796F6",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 50.0001,
    cy: 26.5832,
    rx: 20.8333,
    ry: 10.4167,
    stroke: "#3796F6",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M29.1667 37V49.5",
    stroke: "#3796F6",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path Copy",
    d: "M70.8333 37V49.5",
    stroke: "#3796F6",
    strokeWidth: 1.5
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "tick"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval_2",
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 79.9908,
    cy: 23.7419,
    r: 19.7419,
    fill: "#2CC197"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path 8",
    d: "M73.6038 23.8501L77.7908 28.0969L86.378 19.3872",
    stroke: "white",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 56.2489,
    y: 0,
    width: 47.4839,
    height: 47.4839,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0855127 0 0 0 0 0.588938 0 0 0 0 0.447128 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};

export default __webpack_public_path__ + "static/media/lock.c3fe2dd3.svg";
export { SvgComponent as ReactComponent };